import { Box, IconButton, Stack, Typography, Button } from "@mui/material";
import WushPopover from "../../layout/WushPopover";
import { ShoppingCart } from "@mui/icons-material";
import useCheckoutStore from "../../../stores/public/useCheckoutStore";
import OrderSummary from "../storePages/reservation/checkout/components/OrderSummary";
import destroy from "../../../api/public/storefronts/reservations/destroy";
import show from "../../../api/public/storefronts/orders/show";
import useStorefrontStore from "../../../stores/public/useStorefrontStore";
import { useState } from "react";

export default function CartPopover() {
  const [ forceClose, setForceClose ] = useState(false);
  const { organization } = useStorefrontStore();
  const { reservations, order, setOrder, removeReservation, reset } = useCheckoutStore();

  const refreshOrder = () => {
    show(organization.id, order.id, (response) => {
      setOrder(response);
    });
  };

  const handleRemoveReservation = (reservation) => {
    removeReservation(reservation);
    destroy(organization.id, reservation.id);
    setTimeout(refreshOrder, 500);
  };

  const renderCartContents = () => {
    if(!order || reservations.length === 0) return <Stack>
      <Typography variant="body2">Your cart is empty</Typography>
    </Stack>;

    return (
      <Stack>
        <Stack mb={2}>
          <OrderSummary
            order={order}
            reservations={reservations}
            handleRemoveReservation={handleRemoveReservation}
            showCheckoutButton
            onCheckout={() => {
              setForceClose(true);
              setInterval(() => setForceClose(false), 100);
            }}
          />
        </Stack>
        <Button variant="outlined" onClick={reset}>
          Clear Cart
        </Button>
      </Stack>
    );
  };

  return (
    <Stack direction="row" justifyContent="right" width="100%" my="auto">
      <WushPopover
        side="right"
        forceClose={forceClose}
        anchor={
          <Button>
            <Stack direction="row">
              <IconButton size="small">
                <ShoppingCart sx={{ width: "28px", height: "28px" }} />
              </IconButton>
              <Typography variant="body1" sx={{ my: "auto" }} fontWeight="bold">
                Cart
              </Typography>
              {reservations.length > 0 && <Box
                position="relative"
                right="0"
                height="20px"
                width="20px"
                borderRadius="100px"
                bgcolor="primary.main"
                display="flex"
              >
                <Typography variant="body2" color="#fff" width="100%" textAlign="center" sx={{ my: "auto" }} fontWeight="700">
                  {reservations.length}
                </Typography>
              </Box>}
            </Stack>
          </Button>
        }
      >
        <Stack p={{ xs: 0, sm: 2 }} width={{ xs: "300px", sm: "400px" }}>
          {renderCartContents()}
        </Stack>
      </WushPopover>
    </Stack>
  );
}